import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f685267e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tabs-container" }
const _hoisted_2 = { class: "top-tabs tabs-buttons" }
const _hoisted_3 = { class: "tabs" }
const _hoisted_4 = ["disabled", "title"]
const _hoisted_5 = { class: "tabs" }
const _hoisted_6 = ["disabled", "title"]
const _hoisted_7 = {
  class: "content-container",
  style: {"justify-content":"flex-start"}
}
const _hoisted_8 = { class: "top-content" }
const _hoisted_9 = { class: "form-container selection-form" }
const _hoisted_10 = { class: "flex-col-centered date-picker selection" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "vat-return-date" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "header" }, "VAT Return/Payment Date")
], -1))
const _hoisted_12 = { class: "flex-col-centered selection" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "vat-total",
  class: "header"
}, [
  /*#__PURE__*/_createElementVNode("h3", null, "Total Amount")
], -1))
const _hoisted_14 = { class: "flex-col-centered selection" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "vat-corporate" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "header" }, "Corporate Amount")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex-col-centered selection",
  style: {"padding-top":"10px"}
}, null, -1))
const _hoisted_17 = {
  key: 1,
  class: "flex-row-centered"
}
const _hoisted_18 = ["onSubmit", "disabled"]

import { ref, onMounted, computed, inject } from "vue";
import { TransferPaymentsHelper } from "@/services/helpers/Ledgering/LedgerTransferPaymentsHelper";
import {
    getCols,
    getLabels,
    getDefaultSortCols,
    getDefaultSortOrders
} from "@/services/helpers/Ledgering/LedgerTransferPaymentsHelper";
import GroupedInputButton from "@/components/GroupedInputButton.vue";
import TransferPaymentTable from "@/models/Ledgering/TransferPaymentTable";
import TablePersistentChecking from "@/components/TablePersistentChecking.vue";
import {  loggerKey } from "@/types/ServiceKeys";
import { authService } from "@/auth/authSingleton";
import { GetAuthLevel } from "../config/AuthConfig";
import DbTableCsvHelper from "@/services/helpers/DbTableCsvHelper";
import LedgerTransferStatus from "@/types/LedgerTransferStatus";
import '@vuepic/vue-datepicker/dist/main.css';
import { apiLoggerKey } from '@/types/ServiceKeys';
import { dateFormat, marketSelection, MarketSelection, financialSystemNetworkService, MarketCurrency } from "@/services/helpers/Helper";
import DatePicker from '@vuepic/vue-datepicker';
import MarketSelector from '@/components/MarketSelector.vue';
import PeriodSelector from '@/components/PeriodSelector.vue';
import IPaymentVATForm from '@/Interfaces/VATReturns/IPaymentVATForm';
import CurrencyInput from '@/components/CurrencyInput.vue';
import { fromFormToReq } from '@/Interfaces/VATReturns/IPaymentVATSubmitReq';
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";
import useSpinnerPopup from "@/services/composables/SpinnerPopup";


const getHistory= true;
const transferType= 'HMRC';
const submitHint = 'Submit the payment form';
const exportHint = 'Export VAT Payments';


export default /*#__PURE__*/_defineComponent({
  __name: 'VATPayments',
  setup(__props) {

const labels = getLabels(getHistory);
const cols = getCols(getHistory);
const defaultSortCols = getDefaultSortCols(getHistory);
const defaultSortOrders = getDefaultSortOrders(getHistory);
const LedgerServices = new TransferPaymentsHelper();
const tableError = ref(false);
const originalTransferPayments = ref<TransferPaymentTable[]>();
const displayedTransferPayments = ref<TransferPaymentTable[]>();
const showSubmittedVAT= ref(true);
const working = ref(false);
const VatPayment = ref(false);

const log = inject(loggerKey);
const logger = inject(apiLoggerKey);
const minPaymentDay = computed(()=>
    payment.value.period 
        ? payment.value.period
        : undefined
);
const payment = ref<Partial<IPaymentVATForm>>({ market: marketSelection.value });
//Error Info Props
onMounted(() => {
    document.title='VAT Payments - UV';
    if (!showSubmittedVAT.value) getTransferPayments();
});

async function getTransferPayments() {
    try {
        tableError.value = false;
        displayedTransferPayments.value = undefined;
        const urlParams =
            process.env.VUE_APP_LEDGERING_TRANSFER_PAYMENTS_URL_PARAMS ?? "ledger-transfers";
        const data = await LedgerServices.getTransferPayments(
            urlParams,
            LedgerTransferStatus.COMPLETED,
            marketSelection.value,
            transferType
        );
        originalTransferPayments.value = data.map((x) => new TransferPaymentTable(x));
        displayedTransferPayments.value = originalTransferPayments.value?.filter((x) =>
            x.UserStatusUpdated?.includes("@")
        ); 
    } catch (error) {
        tableError.value = true;
        const errorType = 'Getting Transfer Payments from API';
        useNotifierWithErrFormatter().error({
            errorType,
            error
        })
    }
}
function toggleTabs() {
    if (showSubmittedVAT.value) getTransferPayments();
    showSubmittedVAT.value = !showSubmittedVAT.value;
}
function updateMarketSelection() {
    getTransferPayments();
}
async function downloadAll() {
    const userRoleLevel = GetAuthLevel(authService.getUsersRole());
    // No difference between the two???
    const formattedData = (userRoleLevel > 5 ? originalTransferPayments.value?.filter((x) =>
            x.UserStatusUpdated?.includes("@")) :
            displayedTransferPayments.value) ?? [];
    DbTableCsvHelper.generateCsvDownload(formattedData, "ConfirmedTransferPayments.csv");
}
function validatePaymentRaw(payment: Partial<IPaymentVATForm>): payment is IPaymentVATForm {
    const msgs = [] as string[];
    function assert(result: boolean, msg: string) {
        if (!result) msgs.push(msg);
        return result;
    }
    //short circuit operation
    const result = assert(MarketSelection[payment.market ?? ''],'You must choose a valid market.')
            && assert(!!payment.period, 'You must select a period')
            && assert(!!payment.VATReturnDate, 'You must select a return date')
            && assert(!minPaymentDay.value || payment.VATReturnDate! >= minPaymentDay.value, 'Return date must be within the peroid')
            && assert(payment.VATReturnDate!.zeroTime() <= new Date(), 'Return date must be within the period')
            && assert(!!payment.corporateAmount && !!payment.totalAmount, 'You must enter the VAT amounts')
            && assert(!Number.isNaN(+payment.corporateAmount!), 'Corporate amount must be a valid number')
            && assert(!Number.isNaN(+payment.totalAmount!), 'Total amount must be a valid number')
            && assert(+payment.corporateAmount! <= +payment.totalAmount!, 'Corporate amount must be less than or equal to total');
    if (!result) window.alert(msgs.join('\n'));
    return result;
}
function updateMarket() {
    payment.value.market = marketSelection.value;
}
function onUpdatePeriod() {
    payment.value.VATReturnDate = undefined;
}
//this function name is a bit silly it triggers on every button or other element with a default submit
async function submit(payment: Partial<IPaymentVATForm>) {
    log?.trace(submit.name, payment, working.value);
    if (working.value) return;
    working.value = true;

    // validate data
    // if something wrong, shows warning
    if (validatePaymentRaw(payment)) {
        const json = fromFormToReq(payment);
        const currency = '£';
        const name = submit.name;
        const Message = `submitting payment form: ${JSON.stringify(json)};`;
        const Class = __filename + "/" + name;

        const confirm = window.confirm(
            "Please confirm the VAT " + (VatPayment.value? "payment " : "return ") + "details:\n\n" +
            "Period of the VAT " + (VatPayment.value? "payment " : "return ") + json.period + "\n"+
            "Date of payment " + (VatPayment.value? "made " : "received")  + ": " + json.VATReturnDate + "\n"+
            "Total " + (VatPayment.value? "paid " : "received ") + `: ${currency}${json.totalAmount}\n` +
            `Corporate amount: ${currency}${json.corporateAmount}`
        );
        if (confirm) {
            const close = useSpinnerPopup().show()
            try {
                logger?.LogInformation(Message, Class);
                await financialSystemNetworkService.post(json, process.env.VUE_APP_ADD_PAYMENT_URL_PARAMS ?? 'vat-payments/add');
                useNotifierWithErrFormatter().success({
                    msg: 'VAT payment successfully registered.'
                });
            } catch (error) {
                useNotifierWithErrFormatter().error({
                    errorType: 'Submitting VAT Payment',
                    error
                });
            } finally {
                close();
                working.value = false;
            }
        }
    }
    working.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: _normalizeClass(`button-left ${showSubmittedVAT.value ? 'selected' : 'unselected'}`),
            disabled: showSubmittedVAT.value,
            title: 
                        showSubmittedVAT.value
                            ? 'Currently viewing VAT submission history'
                            : 'Click to go to VAT submission form'
                    ,
            onClick: toggleTabs
          }, " Submitted VAT ", 10, _hoisted_4)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: _normalizeClass(`button-right ${showSubmittedVAT.value ? 'unselected' : 'selected'}`),
            disabled: !showSubmittedVAT.value,
            title: 
                        !showSubmittedVAT.value
                            ? 'Currently viewing VAT submission form'
                            : 'Click to view submitted VAT history'
                    ,
            onClick: toggleTabs
          }, " Confirmed ", 10, _hoisted_6)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        (showSubmittedVAT.value)
          ? (_openBlock(), _createElementBlock("form", {
              key: 0,
              onSubmit: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (submit(payment.value)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(MarketSelector, { onChange: updateMarket }),
                _createVNode(PeriodSelector, {
                  id: "payment-period",
                  modelValue: payment.value.period,
                  "onUpdate:modelValue": [
                    _cache[0] || (_cache[0] = ($event: any) => ((payment.value.period) = $event)),
                    onUpdatePeriod
                  ],
                  showTitle: ""
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(_unref(DatePicker), {
                    id: "vat-return-date",
                    modelValue: payment.value.VATReturnDate,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((payment.value.VATReturnDate) = $event)),
                    placeholder: "Select Date...",
                    format: _unref(dateFormat),
                    minDate: minPaymentDay.value,
                    maxDate: new Date(),
                    startDate: new Date(),
                    "enable-time-picker": false,
                    "prevent-min-max-navigation": "",
                    textInput: "",
                    teleportCenter: "",
                    teleport: "",
                    required: ""
                  }, null, 8, ["modelValue", "format", "minDate", "maxDate", "startDate"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode(CurrencyInput, {
                    id: "vat-total",
                    modelValue: payment.value.totalAmount,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((payment.value.totalAmount) = $event)),
                    currency: _unref(MarketCurrency)[_unref(marketSelection)],
                    min: 0,
                    title: "Total amount of VAT return received",
                    required: ""
                  }, null, 8, ["modelValue", "currency"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createVNode(CurrencyInput, {
                    id: "vat-corporate",
                    modelValue: payment.value.corporateAmount,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((payment.value.corporateAmount) = $event)),
                    min: 0,
                    max: payment.value.totalAmount,
                    title: "The portion that goes to corporate account",
                    required: ""
                  }, null, 8, ["modelValue", "max"])
                ]),
                _createVNode(GroupedInputButton, null, {
                  default: _withCtx(() => [
                    _createElementVNode("button", {
                      title: "Override the validation results of selected to be valid",
                      class: "default-btn btn-vat-payments",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => {VatPayment.value=true; payment.value.VATPayment=true}),
                      type: "submit"
                    }, " Record VAT Payment "),
                    _createElementVNode("button", {
                      title: "Override the validation results of selected to be invalid",
                      class: "default-btn btn-vat-payments",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => {VatPayment.value=false; payment.value.VATPayment=false}),
                      type: "submit"
                    }, " Record VAT Return ")
                  ]),
                  _: 1
                })
              ]),
              _hoisted_16
            ], 32))
          : (_openBlock(), _createElementBlock("div", _hoisted_17, [
              _createVNode(MarketSelector, { onChange: updateMarketSelection }),
              _createElementVNode("button", {
                type: "button",
                class: "default-btn flex-col-centered",
                onClick: downloadAll,
                onSubmit: _withModifiers(downloadAll, ["prevent"]),
                title: exportHint,
                disabled: working.value
              }, " Export to CSV ", 40, _hoisted_18)
            ]))
      ]),
      (!showSubmittedVAT.value)
        ? (_openBlock(), _createBlock(TablePersistentChecking, {
            key: 0,
            Rows: displayedTransferPayments.value,
            Cols: _unref(cols),
            Labels: _unref(labels),
            HasError: tableError.value,
            DefaultSortCols: _unref(defaultSortCols),
            DefaultSortOrders: _unref(defaultSortOrders)
          }, null, 8, ["Rows", "Cols", "Labels", "HasError", "DefaultSortCols", "DefaultSortOrders"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})